<template>
  <div
    class="itemPortfolioDv"
    :class="{ selectedOutline: isSelected && !canRemove }"
    :style="{
      background: portfolioData.color,
    }"
    v-if="portfolioData"
  >
    <img
      class="backgroundBackDv"
      :src="getImageUrl('icon-portfolio-background.png')"
    />
    <div class="contentDv">
      <figure>
        <img
          crossorigin="anonymous"
          :src="getImageUrl(portfolioData.image, portfolioData.directory)"
        />
      </figure>
      <el-tooltip
        v-if="shouldShowTooltip"
        effect="dark"
        :content="portfolioData.category"
        placement="top-start"
      >
        <h2 ref="textElement" class="text" @mouseover="checkOverflow">
          {{ portfolioData.category ?? "-" }}
        </h2>
      </el-tooltip>
      <h2 v-else ref="textElement" class="text" @mouseover="checkOverflow">
        {{ portfolioData.category ?? "-" }}
      </h2>
    </div>
    <IconComponent
      icon="minus.svg"
      class="remove-icon"
      :id="`minus${index}`"
      @click="onRemove()"
      v-if="canRemove"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import IconComponent from "@/components/IconComponent.vue";
import utilService from "@/services/util.service";
export default defineComponent({
  components: {
    IconComponent,
  },
  props: {
    portfolioData: Object,
    index: Number,
    canRemove: Boolean,
    isSelected: Boolean,
  },
  setup(props, context) {
    const getImageUrl = utilService.getImageUrl;

    const onRemove = () => context.emit("onRemove", props.portfolioData);

    const textElement = ref<HTMLElement | null>(null);
    const shouldShowTooltip = ref(false);

    const checkOverflow = () => {
      const el = textElement.value;
      if (el) {
        shouldShowTooltip.value = el.scrollWidth > el.clientWidth;
      }
    };

    onMounted(() => {
      checkOverflow();
    });

    return {
      onRemove,
      getImageUrl,
      textElement,
      shouldShowTooltip,
      checkOverflow,
    };
  },
});
</script>
<style lang="scss" scoped>
@import "./PortfolioCard.scss";

.itemPortfolioDv {
  flex: 0 0 150px;
  max-width: 150px;
  width: 150px;
  border: 1px solid transparent;
  position: relative;
  box-shadow: -2px 3px 18px 0px rgba(75, 70, 92, 0.1);
  background: var(--color-light-purple3);
  border-radius: 10px;
  position: relative;
  padding: 15px;
  display: flex;
  align-items: center;
  cursor: default;
  justify-content: flex-start;

  &.selectedOutline {
    box-shadow: -2px 3px 18px 0px rgba(75, 70, 92, 0.1);
  }

  .backgroundBackDv {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border-radius: 6px;
    z-index: 1;
  }

  .contentDv {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    z-index: 2;
    gap: var(--tile-horizontal-gap);
    overflow: hidden;

    figure {
      flex: 0 0 30px;
      width: 30px;
      height: 30px;
      border-radius: 6px;
      background: #fff;
      padding: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    h2 {
      margin: 0px;
      padding: 0px;
      line-height: 1.4;
      letter-spacing: 0px;
      color: var(--text-color);
      font-size: var(--font-2sm);
      font-weight: 600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100px;
    }
  }

  .remove-icon {
    position: absolute;
    top: -8px;
    cursor: pointer;
    right: -8px;
    width: 20px;
    height: auto;
    z-index: 2;
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &.selected {
    border-color: var(--orange);
  }
}
[dir="rtl"] {
  .itemPortfolioDv {
    .remove-icon {
      right: auto;
      left: -8px;
    }
  }
}
@media screen and (min-width: 1280px) and (max-width: 1891px) {
  .itemPortfolioDv {
    height: 45px;
    max-width: 130px;
    width: 130px;

    .contentDv h2 {
      font-size: var(--font-1xs);
    }
  }
}

@media screen and (max-width: 767px) {
  .itemPortfolioDv {
    height: 45px;
    max-width: 130px;
    width: 130px;

    .contentDv h2 {
      font-size: var(--font-1xs);
    }
  }
}
</style>
